import React, { useState } from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import Slider from '@mui/material/Slider';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Divider from '@mui/material/Divider';

import SettingsIcon from '@mui/icons-material/Settings';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import FastRewindIcon from '@mui/icons-material/FastRewind';
import FastForwardIcon from '@mui/icons-material/FastForward';
import MenuIcon from '@mui/icons-material/Menu';

import CreateIcon from '@mui/icons-material/Create';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

import BorderColorIcon from '@mui/icons-material/BorderColor';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import PrintIcon from '@mui/icons-material/Print';
import TuneIcon from '@mui/icons-material/Tune';
import PauseIcon from '@mui/icons-material/Pause';
import { ReactComponent as MetronomeIcon } from "../29689/metronome.svg";

import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import DeleteIcon from '@mui/icons-material/Delete';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import PlaybackSettingsPage from "./PlaybackSettingsPage.js"
import PrintingPage from "./PrintingPage.js"
import SettingsPage from "./SettingsPage.js"
import ScoreManagementPage from "./ScoreManagementPage.js"
import Keyboard from "./Keyboard/Keyboard.js"

import { styled } from '@mui/material/styles';

export default styled(Slider)(({ theme }) => ({
  // color: theme.palette.primary.main,

  height: 6,
  '& .MuiSlider-track': {
    border: 'none',
	backgroundImage:"linear-gradient(90deg, rgba(0,141,254,1) 0%, rgba(81,202,255,1) 100%)",
	
  },
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    border: '4px solid transparent',
	background: "linear-gradient(white, white) padding-box, linear-gradient(90deg, rgba(0,141,254,1) 0%, rgba(81,202,255,1) 100%) border-box",
	boxShadow: '0 0 4px rgba(0,0,0,0.5)',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
		boxShadow: '0 0 0 6px rgba(0,0,0,0.15)',
    },
    '&:before': {
      display: 'none',
    },
	
	transition: "unset",
	
	

  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 18,
    background: 'unset',
    padding: 0,
    width: 32,
	
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: theme.palette.primary.main,
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&:before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },

  },
}));